import { CV_COPY, FIELD_COPY } from '../data/application-copy';

// Rebecca rejects a CV of 2,000,000 bytes or more.
const MAX_CV_BYTES = 2000000;

// Rebecca's own rules. The email pattern accepts internationalised domains.
const EMAIL_RE =
  /^[^\s@]+@(?:[^\s@.]+\.)+(?:xn--[A-Za-z0-9-]{1,59}|\p{L}{2,63})$/u;
const PHONE_RE = /^[+]?[()\d\s.-]{7,20}$/;

// Enabled fields only, in Rebecca's order. A copy: the feed is not mutated.
export const enabledFields = (fields) =>
  (fields || [])
    .filter((field) => field.enabled)
    .sort((a, b) => a.order - b.order);

export const validateCv = (file) => {
  if (!file) return CV_COPY.required;
  if (file.type !== 'application/pdf') return CV_COPY.notPdf;
  if (file.size >= MAX_CV_BYTES) return CV_COPY.tooLarge;
  return null;
};

const isPositiveAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0;
};

// Values are trimmed, so whitespace-only counts as empty and what reaches
// Rebecca is what the format rule checked.
export const validateAnswer = ({ subtype, required }, rawValue) => {
  const value = (rawValue || '').trim();
  if (value === '') return required ? FIELD_COPY.required : null;
  if (subtype === 'EMAIL' && !EMAIL_RE.test(value)) return FIELD_COPY.email;
  if (subtype === 'PHONE' && !PHONE_RE.test(value)) return FIELD_COPY.phone;
  if (subtype === 'SALARY' && !isPositiveAmount(value)) {
    return FIELD_COPY.salary;
  }
  return null;
};

// One entry per enabled field, in display order; blanks are sent as "".
export const buildAnswers = (fields, answers) =>
  fields.map((field) => ({
    field_id: field.id,
    value: (answers[field.id] || '').trim(),
  }));
